import React,{useContext} from 'react'
import {TransactionContext} from '../context/TransactionContext'
import dummyData from '../utils/dummyData'
import {ShortenAddress} from '../utils/shortenAddress'

const TransactionCard=({addressTo,addressFrom,timestamp,message,keyword,amount})=>{
    return(
        <div className='bg-[#181918] m-4 flex flex-1
        2xl:min-2-[450px]
        2xl:max-2-[500px]
        sm:min-2-[270px]
        sm:max-2-[300px]
        flex-col p-3 rounded-md hover:shadow-2xl
        '>
            <div className='flex flex-col items-center w-full mt-3'>
                <div className='w-full mb-6 p-2'>
                   <a href={`https://goerli.etherscan.io/tx/${addressFrom}`} target='_blank' rel='noopener noreferrer'>
                    <p className='text-white text-base'>From:{ShortenAddress(addressFrom)}</p>
                   </a> 
                   <a href={`https://goerli.etherscan.io/tx/${addressTo}`} target='_blank' rel='noopener noreferrer'>
                    <p className='text-white text-base'>From:{ShortenAddress(addressTo)}</p>
                   </a> 
                   <p className='text-white text-base'>Amount: {amount} ETH</p>
                   {message && <>
                       <br></br>
                       <p className='text-white text-base'>Message:{message}</p>
                   </>}
                </div>
                <div className='bg-black p-3 px-5 w-max rounde-3xl mt-5 shadow-2xl'>
                    <p className='text-[#37c7da] font-bold'>{timestamp}</p>
                   </div>
            </div>
        </div>
    )
}   

const Transactions = () =>  {
    const {currentAccount,transactions} = useContext(TransactionContext)
    return (
        <div className='flex w-full justify-center items-center 2xl:px-20 gradient-bg-transactions'>
            <div className='flex flex-col md:p-12 py-12 px-4'>
                {currentAccount ? 
                <h3 className='text-white text-3xl text-center my-2'> Latest Transactions</h3>
                :<h3 className='text-white text-3xl text-center my-2'> Coonect Your account to see the Latest Transactions</h3>
                }
                <div className='flex flex-wrap justify-center items-center mt-10'>
                    {transactions.reverse().map((transaction,index)=>(
                        <TransactionCard key={index} {...transaction} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Transactions
